import { type EvaluationChatResponse } from "../api";
import { Utility } from "./utility";

export interface EvaluationChat extends EvaluationChatResponse {}

export class EvaluationChat extends Utility<EvaluationChat> {
  constructor(init?: Partial<EvaluationChatResponse>) {
    super();
    Object.assign(this, init);
  }
}
